module.exports = __webpack_public_path__ + "static/media/banner-promocoes-especias-sem-cupom.e3c8f9a2.png";